import { Collapse, Stack, styled } from '@mui/material'
import { Button } from 'ComponentLibrary/src/atoms/Buttons/Button'
import { Children, ReactNode, useState } from 'react'
import { tokens } from 'ComponentLibrary/style-dictionary/output'

export const ShowMore = ({
    children,
    threshold = 1,
    gap = 0,
    showMoreLabel,
    showLessLabel,
}: {
    children: ReactNode
    threshold?: number
    gap?: number
    showMoreLabel?: string
    showLessLabel?: string
}) => {
    const [checked, setChecked] = useState(false)

    if (Children.count(children) <= threshold) {
        return (
            <Stack direction="column" gap={`${gap}px`}>
                {children}
            </Stack>
        )
    }

    const childrenArray = Children.toArray(children)

    return (
        <Stack direction="column" gap={tokens.SizingSpacing050}>
            <Stack direction="column" gap={`${gap}px`}>
                {childrenArray.slice(0, threshold)}
            </Stack>
            <Collapse in={checked} collapsedSize={0} sx={{ marginTop: `${gap}px` }} unmountOnExit>
                <Stack direction="column" gap={`${gap}px`}>
                    {childrenArray.slice(threshold)}
                </Stack>
            </Collapse>
            <ShowMoreButton checked={checked} setChecked={setChecked} showMoreLabel={showMoreLabel} showLessLabel={showLessLabel} />
        </Stack>
    )
}

export const ShowMoreButton = ({
    checked,
    setChecked,
    showMoreLabel = 'Mehr anzeigen...',
    showLessLabel = 'Weniger anzeigen',
}: {
    checked: boolean
    setChecked: React.Dispatch<React.SetStateAction<boolean>>
    showMoreLabel?: string
    showLessLabel?: string
}) => {
    return <StyledButton variant="text" label={!checked ? showMoreLabel : showLessLabel} onClick={() => setChecked((prev) => !prev)} />
}

const StyledButton = styled(Button, {
    shouldForwardProp: (prop: string) => prop[0] !== '$',
})<{ $hidden?: boolean }>(({ $hidden }) => ({
    ...tokens.Headline5,
    color: tokens.ColorTextBoldest,
    padding: tokens.SizingSpacingNone,
    transition: 'opacity 0.4s ease-in',
    opacity: $hidden ? 0 : 1,
}))
